import { useEffect, useState } from "react";
import axios from "axios";
import { useLanguage } from "../context/LanguageContext";
import { useT } from "../i18n";
import { Play, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Gallery = () => {
  const { lang } = useLanguage();
  const t = useT(lang);
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    axios.get(`${API}/gallery`).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="py-24 md:py-32">
      <div className="container-wc">
        <div className="max-w-3xl mb-16 fade-up">
          <div className="flex items-center gap-3 mb-4">
            <span className="divider-gold" />
            <span className="eyebrow">{t.nav.gallery}</span>
          </div>
          <h1 className="h-display text-5xl md:text-6xl mb-6">{t.gallery.title}</h1>
          <p className="text-dim text-lg leading-relaxed">{t.gallery.subtitle}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {items.map((it, i) => (
            <button
              key={it.id}
              data-testid={`gallery-item-${i}`}
              onClick={() => setSelected(it)}
              className={`relative overflow-hidden border border-goldSoft hover:border-gold group ${
                i % 5 === 0 ? "md:col-span-2 md:row-span-2 aspect-square md:aspect-[2/1.4]" : "aspect-square"
              }`}
            >
              {it.type === "video" ? (
                <>
                  <video src={it.url} className="w-full h-full object-cover img-moody" muted />
                  <span className="absolute inset-0 flex items-center justify-center bg-black/40">
                    <Play className="text-gold" size={40} />
                  </span>
                </>
              ) : (
                <img src={it.url} alt={lang === "el" ? it.caption_el : it.caption_en} className="w-full h-full object-cover img-moody group-hover:scale-105" style={{ transition: "transform 500ms ease" }} />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <span className="font-serif text-lg text-gold">{lang === "el" ? it.caption_el : it.caption_en}</span>
              </div>
            </button>
          ))}
        </div>

        {selected && (
          <div className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4" onClick={() => setSelected(null)} data-testid="gallery-modal">
            <button className="absolute top-6 right-6 text-gold" onClick={() => setSelected(null)} data-testid="gallery-close">
              <X size={28} />
            </button>
            <div className="max-w-5xl max-h-[85vh]" onClick={(e) => e.stopPropagation()}>
              {selected.type === "video" ? (
                <video src={selected.url} controls autoPlay className="max-h-[85vh]" />
              ) : (
                <img src={selected.url} alt="" className="max-h-[85vh] object-contain" />
              )}
              <p className="text-center text-gold mt-4 font-serif text-xl">{lang === "el" ? selected.caption_el : selected.caption_en}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Gallery;
